module.exports = __webpack_public_path__ + "static/media/youtube.6e1d8d34.svg";